/* eslint-disable max-classes-per-file*/
export class YesNoValueConverter {
	public toView(value): string {
		if (!value) {
			value = '';
		}
		const v = value.toString().trim().toUpperCase();

		switch (v) {
			case 'Y':
				return 'YES';
			case 'N':
			case '':
				return 'NO';
			default:
				return '';
		}
	}
}

// tslint:disable:max-classes-per-file
export class BooleanAsYesNoValueConverter {
	public toView(value): string {
		if (value) {
			return 'YES';
		}
		return 'NO';
	}
}
